// @flow

import {
  ClaimFree,
  Duration,
  Mileage,
  Color,
  Accessories,
  ExtraContracts,
  ConfigPackages,
  Bundle,
} from '../../choiceGroups';

export const choiceGroupMapper = {
  packages: ConfigPackages,
  colors: Color,
  durations: Duration,
  mileages: Mileage,
  claim_free: ClaimFree,
  bundles: Bundle,
  extras: Accessories,
  insurances: ExtraContracts,
};

export default null;
